import { useEffect, useState } from 'react'
import { Flex, Alert, AlertIcon, AlertDescription, Button } from '@chakra-ui/react'
import { Plus } from 'components/icons'

import { useCustomFormViewer } from '../../../contexts/CustomFormViewerManager/Provider'
import CustomFormViewerQuestion from '../../../components/CustomFormViewerQuestion'

export default function CompensacaodeHoras() {
  const { questions, formMethods } = useCustomFormViewer()
  const { watch } = formMethods
  const [periodo1PadraoCerto, setPeriodo1PadraoCerto] = useState(false)
  const [periodo1Ultrapassou, setPeriodo1Ultrapassou] = useState(false)

  const [periodo2PadraoCerto, setPeriodo2PadraoCerto] = useState(false)
  const [periodo2Ultrapassou, setPeriodo2Ultrapassou] = useState(false)
  const [periodo2Visibility, setPeriodo2Visibility] = useState(false)

  const [periodo3PadraoCerto, setPeriodo3PadraoCerto] = useState(false)
  const [periodo3Ultrapassou, setPeriodo3Ultrapassou] = useState(false)
  const [periodo3Visibility, setPeriodo3Visibility] = useState(false)

  function validarSeEstaNoPadraoCerto(valor: string) {
    // Verifica se está no formato HH:mm
    const regex = /^\d{2}:\d{2}$/
    if (!regex.test(valor)) return false

    return true
  }

  function validarHorasTrabalho(valor: string) {
    const [horasStr, minutosStr] = valor.split(':')
    const horas = parseInt(horasStr, 10)
    const minutos = parseInt(minutosStr, 10)

    // Checagem de validade básica (ex: 25:99 não é válido)
    if (horas > 23 || minutos > 59) return false

    const totalMinutos = horas * 60 + minutos

    // Máximo permitido: 8 horas = 480 minutos
    return totalMinutos <= 480
  }

  const titleForQuestion = Object.fromEntries(questions.map((q) => [q.title, q.slug]))

  //PERIODO 1
  const periodo1Duracao = watch ? watch(`form_answers.${titleForQuestion['PERÍODO 1 - Duração']}`) : undefined
  //PERIODO 2
  const periodo2Duracao = watch ? watch(`form_answers.${titleForQuestion['PERÍODO 2 - Duração']}`) : undefined
  //PERIODO 3
  const periodo3Duracao = watch ? watch(`form_answers.${titleForQuestion['PERÍODO 3 - Duração']}`) : undefined

  //PERIODO 1
  useEffect(() => {
    if (periodo1Duracao) {
      if (validarSeEstaNoPadraoCerto(periodo1Duracao)) {
        if (validarHorasTrabalho(periodo1Duracao)) {
          setPeriodo1Ultrapassou(true)
        } else {
          setPeriodo1Ultrapassou(false)
        }
        setPeriodo1PadraoCerto(true)
      } else {
        setPeriodo1PadraoCerto(false)
      }
    }
  }, [periodo1Duracao])

  //PERIODO 2
  useEffect(() => {
    if (periodo2Duracao) {
      if (validarSeEstaNoPadraoCerto(periodo2Duracao)) {
        if (validarHorasTrabalho(periodo2Duracao)) {
          setPeriodo2Ultrapassou(true)
        } else {
          setPeriodo2Ultrapassou(false)
        }
        setPeriodo2PadraoCerto(true)
      } else {
        setPeriodo2PadraoCerto(false)
      }
    }
  }, [periodo2Duracao])

  //PERIODO 3
  useEffect(() => {
    if (periodo3Duracao) {
      if (validarSeEstaNoPadraoCerto(periodo3Duracao)) {
        if (validarHorasTrabalho(periodo3Duracao)) {
          setPeriodo3Ultrapassou(true)
        } else {
          setPeriodo3Ultrapassou(false)
        }
        setPeriodo3PadraoCerto(true)
      } else {
        setPeriodo3PadraoCerto(false)
      }
    }
  }, [periodo3Duracao])

  if (!questions) return null

  return (
    <Flex bg="transparent" flexDir="column" gap={2} borderTop="1px solid" borderColor="primary">
      {questions.map((question, index) => {
        const questionAboutPeriod = question.title?.includes('PERÍODO')
        const match = question.title?.match(/PERÍODO (\d+) -/)
        let number = null

        if (questionAboutPeriod) {
          if (match) {
            number = parseInt(match[1], 10)
          }
        }

        //PERIODO 1
        if (question.title == 'PERÍODO 1 - Duração') {
          return (
            <Flex
              key={question.id}
              w="full"
              flexDir={'column'}
              border={
                periodo1Duracao && !periodo1PadraoCerto
                  ? '1px solid'
                  : periodo1Duracao && !periodo1Ultrapassou
                  ? '1px solid'
                  : 'none'
              }
              borderColor={'red.500'}
              rounded={'md'}
            >
              <CustomFormViewerQuestion
                question={question}
                index={index}
                questionsLength={questions?.length}
                disabled={false}
              />
              {periodo1Duracao && !periodo1PadraoCerto && (
                <Alert status="error" rounded={'md'}>
                  <AlertIcon />
                  <AlertDescription>Padrão incorreto</AlertDescription>
                </Alert>
              )}
              {periodo1Duracao && !periodo1Ultrapassou && (
                <Alert status="error" rounded={'md'}>
                  <AlertIcon />
                  <AlertDescription>Limite máximo atingido</AlertDescription>
                </Alert>
              )}
            </Flex>
          )
        }

        //PERIODO 2
        if (number == 2 && !periodo2Visibility) {
          if (question.title == 'PERÍODO 2 - Data da compensação de horas') {
            return (
              <Button
                key={index}
                onClick={() => setPeriodo2Visibility(true)}
                variant="outline"
                leftIcon={<Plus />}
                borderStyle="dashed"
              >
                Adicionar período 2
              </Button>
            )
          } else {
            return <></>
          }
        }
        if (question.title == 'PERÍODO 2 - Duração') {
          return (
            <Flex
              key={question.id}
              w="full"
              flexDir={'column'}
              border={
                periodo2Duracao && !periodo2PadraoCerto
                  ? '1px solid'
                  : periodo2Duracao && !periodo2Ultrapassou
                  ? '1px solid'
                  : 'none'
              }
              borderColor={'red.500'}
              rounded={'md'}
            >
              <CustomFormViewerQuestion
                question={question}
                index={index}
                questionsLength={questions?.length}
                disabled={false}
              />
              {periodo2Duracao && !periodo2PadraoCerto && (
                <Alert status="error" rounded={'md'}>
                  <AlertIcon />
                  <AlertDescription>Padrão incorreto</AlertDescription>
                </Alert>
              )}
              {periodo2Duracao && !periodo2Ultrapassou && (
                <Alert status="error" rounded={'md'}>
                  <AlertIcon />
                  <AlertDescription>Limite máximo atingido</AlertDescription>
                </Alert>
              )}
            </Flex>
          )
        }

        //PERIODO 3
        if (number == 3 && !periodo3Visibility) {
          if (question.title == 'PERÍODO 3 - Data da compensação de horas' && periodo2Visibility) {
            return (
              <Button
                key={index}
                onClick={() => setPeriodo3Visibility(true)}
                variant="outline"
                leftIcon={<Plus />}
                borderStyle="dashed"
              >
                Adicionar período 3
              </Button>
            )
          } else {
            return <></>
          }
        }
        if (question.title == 'PERÍODO 3 - Duração') {
          return (
            <Flex
              key={question.id}
              w="full"
              flexDir={'column'}
              border={
                periodo3Duracao && !periodo3PadraoCerto
                  ? '1px solid'
                  : periodo3Duracao && !periodo3Ultrapassou
                  ? '1px solid'
                  : 'none'
              }
              borderColor={'red.500'}
              rounded={'md'}
            >
              <CustomFormViewerQuestion
                question={question}
                index={index}
                questionsLength={questions?.length}
                disabled={false}
              />
              {periodo3Duracao && !periodo3PadraoCerto && (
                <Alert status="error" rounded={'md'}>
                  <AlertIcon />
                  <AlertDescription>Padrão incorreto</AlertDescription>
                </Alert>
              )}
              {periodo3Duracao && !periodo3Ultrapassou && (
                <Alert status="error" rounded={'md'}>
                  <AlertIcon />
                  <AlertDescription>Limite máximo atingido</AlertDescription>
                </Alert>
              )}
            </Flex>
          )
        }

        return (
          <CustomFormViewerQuestion
            key={index}
            index={index}
            questionsLength={questions.length}
            question={question}
            disabled={false}
          />
        )
      })}
    </Flex>
  )
}
